import { api } from './api';
import {
  Customer,
  CreateCustomerRequest,
  UpdateCustomerRequest,
  CustomerQueryParams,
  PaginatedCustomers,
  CustomerSummary,
} from '../types/customer.types';

export const customerService = {
  // Get all customers
  getAll: async (): Promise<Customer[]> => {
    const response = await api.get('/customers');
    return response.data;
  },

  // One page of customers, searched and filtered on the server
  getPage: async (query: CustomerQueryParams): Promise<PaginatedCustomers> => {
    const params = {
      page: query.page,
      limit: query.limit,
      ...(query.search ? { search: query.search } : {}),
      ...(query.isActive !== undefined ? { isActive: query.isActive } : {}),
      ...(query.credit ? { credit: query.credit } : {}),
      ...(query.sortBy ? { sortBy: query.sortBy } : {}),
      ...(query.sortOrder ? { sortOrder: query.sortOrder } : {}),
    };
    const response = await api.get<PaginatedCustomers>('/customers/paginated', { params });
    return response.data;
  },

  getSummary: async (): Promise<CustomerSummary> => {
    const response = await api.get<CustomerSummary>('/customers/summary');
    return response.data;
  },

  // Get customer by ID
  getById: async (id: string): Promise<Customer> => {
    const response = await api.get(`/customers/${id}`);
    return response.data;
  },

  // Create new customer
  create: async (data: CreateCustomerRequest): Promise<Customer> => {
    const response = await api.post('/customers', data);
    return response.data;
  },

  // Update customer
  update: async (id: string, data: UpdateCustomerRequest): Promise<Customer> => {
    const response = await api.patch(`/customers/${id}`, data);
    return response.data;
  },

  // Delete customer
  delete: async (id: string): Promise<void> => {
    await api.delete(`/customers/${id}`);
  },

  // Get active customers (for dropdowns)
  getActive: async (): Promise<Customer[]> => {
    const response = await api.get<Customer[]>('/customers', { params: { isActive: true } });
    return response.data;
  },
};
